import { Col, Row } from 'antd';
import evaluationTypes from '../../../../utils/evaluationType.json';

const WorkerInfoHeader = ({ patientToAdmission, reservation }) => {
  const evalType = evaluationTypes['PE']?.find(t => t.value === patientToAdmission.evaluation_type);

  return (
    <Row className="worker-info-header mb-30" gutter={[0, 0]}>
      <Col lg={12} xs={24}>
        <span>Trabajador: <strong>{patientToAdmission.userFirstName} {patientToAdmission.userLastName}</strong></span>
      </Col>
      <Col lg={12} xs={24}>
        <span>Empresa: <strong>{reservation?.company?.business_name}</strong></span>
      </Col>
      <Col lg={12} xs={24}>
        <span>DNI: <strong>{patientToAdmission.documentNumber}</strong></span>
      </Col>
      {reservation?.outsourcing_id && (
        <Col lg={12} xs={24}>
          <span>Subcontrata: <strong>{reservation.outsourcing?.business_name}</strong></span>
        </Col>
      )}
      <Col lg={12} xs={24}>
        <span>Tipo de evaluación: <strong>{evalType?.text || '—'}</strong></span>
      </Col>
      {reservation?.third_company_id && (
        <Col lg={12} xs={24}>
          <span>Tercera Empresa: <strong>{reservation.third_company?.business_name}</strong></span>
        </Col>
      )}
    </Row>
  );
};

export default WorkerInfoHeader;
